import { FC, useEffect, useState } from 'react';
import SwiperCore, { A11y, EffectFade, SwiperOptions } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';

import { replaceWhiteSpacesWithUnderscore } from '../../../utils/strings';
import { useIsInEditorMode } from '../../../utils/use-is-in-editor-mode';

SwiperCore.use([A11y, EffectFade]);

interface TabsContentProps {
  isInEditor?: boolean;
  childComponents: JSX.Element[];
  activeItemId: number;
  effect?: SwiperOptions['effect'];
}

export const TabsContent: FC<TabsContentProps> = ({ isInEditor, childComponents, activeItemId, effect }) => {
  const [swiper, setSwiper] = useState<SwiperCore | null>();
  const { isInEditorMode } = useIsInEditorMode(isInEditor);

  useEffect(() => {
    swiper?.slideTo(Number(activeItemId));
  }, [activeItemId, swiper]);

  if (isInEditorMode) {
    return (
      <>
        {childComponents.map((item, index) => {
          const key = `tab-content-${index}`;
          return (
            <div
              className={classNames('cmp-tabs__author-tab-content snowflake-tabs-author-content', {
                active: activeItemId === index,
              })}
              key={key}
            >
              {childComponents[index]}
            </div>
          );
        })}
      </>
    );
  }

  return (
    <div data-testid="content" className="snowflake-tabs-published-content">
      <Swiper
        effect={effect}
        speed={1000}
        allowTouchMove={false}
        onSwiper={(swiperCore: SwiperCore) => {
          setSwiper(swiperCore);
        }}
        fadeEffect={{ crossFade: true }}
        spaceBetween={1}
      >
        {childComponents.map((childComponent) => {
          return (
            <SwiperSlide
              data-testing={replaceWhiteSpacesWithUnderscore(
                childComponent.props['cq:panelTitle']
              )?.toLocaleLowerCase()}
              tag="span"
              key={childComponent.key}
            >
              <div role="tabpanel">{childComponent}</div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
